import { REVIEW_URL } from "./i18n";

export const reviewText = (name, service) =>
  `Ciao ${name || ""}! 🌸 Grazie per aver scelto Gioia Centro Estetico${service ? ` per il tuo ${service.toLowerCase()}` : ""}. ` +
  `Se ti sei trovata bene, ci aiuteresti tantissimo lasciando una breve recensione su Google: ${REVIEW_URL}\n` +
  `Ci vuole solo un minuto. Grazie di cuore, Gioia`;

export const toIntl = (raw) => {
  const d = (raw || "").replace(/\D/g, "").replace(/^00/, "");
  if (!d) return "";
  return d.startsWith("39") && d.length > 10 ? d : `39${d.replace(/^0+(?=3)/, "")}`;
};
